<!--
 * @Author: kenneth
 * @Date: 2023-07-10 15:53:26
 * @Last Modified by: zhaoyang
 * @Last Modified time: 2024-12-20 19:17:06
-->

<template>
    <tab>
        <div class="borrow">
            <div
                class="borrow-tab"
            >
                <button
                    class="button"
                    :class="{'button-active button-active-left': tab === 'applicationLoan'}"
                    @click="changeToApplication"
                >
                    {{ $t('FAQAPPLICATIONLOANS') }}
                </button>
                <button
                    class="button"
                    :class="{'button-active button-active-right': tab !== 'applicationLoan'}"
                    @click="changeToPayment"
                >
                    {{ $t('FAQPAYMENTREPAYMENT') }}
                </button>
            </div>
            <yqg-md-preview
                v-if="tab === 'applicationLoan'"
                :md-text="$t('mdText', [yqdContact.email, finContact.email])"
            />
            <yqg-md-preview
                v-else
                :md-text="$t('paymentText', [yqdContact.email, finContact.email, overdueRate])"
            />
        </div>
    </tab>
</template>

<script>
import {mapState} from 'vuex';

import Tab from '../../component/tab';
import EN_US from './constant/applicationLoan/en-us';
import ID from './constant/applicationLoan/id';
import PAYMENT_EN_US from './constant/payment/en-us';
import PAYMENT_ID_US from './constant/payment/id';

export default {
    name: 'Borrow',

    data() {
        return {
            tab: 'applicationLoan'
        };
    },

    i18n: {
        messages: {
            en: {mdText: EN_US, paymentText: PAYMENT_EN_US},
            id: {mdText: ID, paymentText: PAYMENT_ID_US}
        }
    },

    computed: {
        ...mapState('interestRate', ['status']),
        ...mapState('contact', [
            'yqdContact',
            'finContact'
        ]),

        overdueRate() {
            const {
                $i18n: {locale},
                status: {
                    overdueRateContentForIdn,
                    overdueRateContentForEn
                }
            } = this;

            return locale === 'en' ? overdueRateContentForEn : overdueRateContentForIdn;
        },
    },

    methods: {
        changeToApplication() {
            this.tab = 'applicationLoan';
        },

        changeToPayment() {
            this.tab = 'payment';
        }
    },

    components: {
        Tab
    }
};

</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .borrow-tab {
        display: flex;
        width: max-content;
        position: relative;
        margin-bottom: 0.4rem;

        @media screen and (max-width: $screen-md) {
            width: 100%;
        }

        .button {
            border: none;
            background-color: unset;
            padding: 0;
            font-size: 0.16rem;
            margin-bottom: 0.06rem;
            cursor: pointer;
            position: relative;

            &:hover,
            &:active {
                color: #005732;
            }

            @media screen and (max-width: $screen-md) {
                font-size: 0.14rem;
                width: 50%;
            }

            &:nth-child(1) {
                margin-right: 0.2rem;

                @media screen and (max-width: $screen-md) {
                    margin-right: unset;
                }
            }

            &-active {
                font-weight: 700;

                &::after {
                    content: "";
                    width: 100%;
                    position: absolute;
                    bottom: -0.06rem;
                    background: #3fca58;
                    height: 0.06rem;
                    border-radius: 0.03rem;
                    z-index: 1;
                    font-weight: 700;
                }

                &-left {
                    &::after {
                        left: 0;
                    }
                }

                &-right {
                    &::after {
                        right: 0;
                    }
                }
            }
        }

        &::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            background: #ebeef1;
            height: 0.06rem;
            border-radius: 0.03rem;
        }
    }
</style>
